export const Circle = (h) => (props) => (h("svg", { ...props, fill: "currentColor", viewBox: "0 0 24 24", "aria-hidden": "true" }, h("circle", { cx: 12, cy: 12, r: 12 })));
//# sourceMappingURL=Circle.js.map
